import { OpenModalEvent } from '@ui-common/components/Modal'
import { getCancelEditingPromptModalEvent } from '@ui-common/components/Modal/CancelEditingModal'
import type { FileObject } from '@ui-components/types'
import { FieldValues, get } from 'react-hook-form'
import { IntlShape } from 'react-intl'
import * as R from 'remeda'

const openCancelEditingPromptModal = ({
  intl,
  onConfirm,
  openModal,
}: {
  intl: IntlShape
  onConfirm: () => void
  openModal: (modalEvent: OpenModalEvent) => void
}): void => {
  openModal(
    getCancelEditingPromptModalEvent({
      onConfirm,
      intl,
      header: intl.formatMessage({
        id: 'common-back-to-application-unsaved-header',
      }),
      text: intl.formatMessage(
        {
          id: 'common-back-to-application-unsaved-warning',
        },
        { continue_action: intl.formatMessage({ id: 'common-continue-anyway' }) },
      ),
    }),
  )
}

const isUploading = <TFormData extends FieldValues>(names: string[], data: TFormData): boolean => {
  return names.some((name) => {
    if (get(data, name)) {
      const uploadingArray = (get(data, name) as FileObject[]).filter(
        (item: FileObject) => item.uploadProgress !== undefined && item.uploadProgress !== 100,
      )

      return uploadingArray?.length !== 0
    }
    return false
  })
}

const getSubmitDataWithValidFiles = <TFormData extends FieldValues>(names: string[], data: TFormData): TFormData => {
  let result = data
  names.map((name) => {
    if (get(result, name)) {
      const validFiles = (get(result, name) as FileObject[]).filter(
        (item: FileObject) => item.uploadProgress === 100 && item.isValid && !item.error && !!item.fileId,
      )
      const namePath = name.split('.')

      if (validFiles) {
        const newData = R.setPath(result, namePath as never, validFiles as never)
        result = { ...result, ...newData }
      } else {
        const newData = R.setPath(result, namePath as never, undefined as never)
        result = { ...result, ...newData }
      }
    }
  })
  return result
}

const extractFileIds = (files: FileObject[] | undefined): string[] => {
  if (files === undefined) {
    return []
  }
  return files.map((file) => file.fileId).filter((id) => id !== undefined)
}

export { extractFileIds, getSubmitDataWithValidFiles, isUploading, openCancelEditingPromptModal }
